import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./PaperCard.css";
import { useState, useRef, useEffect } from "react";

export default function PaperCard(props) {
  const paper = props.props;

  return (
    <div className="paper-card">
      <p>Paper ID: {paper.paperID}</p>
      <p style={{ fontWeight: "bold" }}>{paper.title}</p>
      <p>Authors: {paper.authors}</p>
    </div>
  );
}
